import { Routes, Route } from "react-router-dom";
import MainContainer from "./layout/MainContainer";
import Pages from "./pages";

const Routing = () => {
  return (
    <Routes>
      <Route path="/" element={<Pages.Login />} />
      <Route path="/signup" element={<Pages.Signup />} />
      <Route path="/forgot-password" element={<Pages.ForgotPassword />} />
      <Route path="/otp" element={<Pages.OtpVerification />} />
      <Route path="/recoverymail" element={<Pages.RecoveryMail />} />
      <Route path="/reset-password" element={<Pages.ResetPassword />} />
      <Route element={<MainContainer />}>
        <Route path="/dashboard" element={<Pages.Editor />} />
        <Route path="/recent-designs" element={<Pages.RecentDesigns />} />
        <Route path="/how-it-works" element={<Pages.HowItWorks />} />
        <Route path="/manage-profile" element={<Pages.Account />} />
      </Route>
    </Routes>
  );
};

export default Routing;
